import React, { useMemo } from 'react';
import CompositePlatformField from '../../components/CompositePlatformField';
import { CurrencyEnum, ItemVo } from '#services/api';

interface PlatformPriceCellProps {
  /** 商单平台价格数据（ItemVo 数组） */
  starMapPrices?: ItemVo[];
  /** 供应商价格数据（ItemVo 数组） */
  supplierPrices?: ItemVo[];
  /** 主平台报价项目（用于决定显示逻辑） */
  quoteProject?: string;
  /** 商单平台价格币种 */
  starMapCurrency?: CurrencyEnum;
  /** 供应商价格币种 */
  supplierCurrency?: CurrencyEnum;
  /** 视图币种 */
  viewCurrency?: CurrencyEnum;
  /** 是否展示数据切换按钮 */
  showRadioGroup?: boolean;
}

/**
 * 平台价格信息展示组件
 * 使用 CompositePlatformField 实现复合字段逻辑
 */
const PlatformPriceCell: React.FC<PlatformPriceCellProps> = ({
  starMapPrices = [],
  supplierPrices = [],
  quoteProject,
  starMapCurrency,
  supplierCurrency,
  viewCurrency,
  showRadioGroup = true,
}) => {
  
  const starMapData = useMemo(() => starMapPrices.map((item) => ({
    type: item.name || '',
    value: item.value,
    alias: item.alias,
    currency: starMapCurrency,
  })), [starMapPrices, starMapCurrency]);

  const supplierData = useMemo(() => supplierPrices.map((item) => ({
    type: item.name || '',
    value: item.value,
    alias: item.alias,
    currency: supplierCurrency,
  })), [supplierPrices, supplierCurrency]);

  return (
    <CompositePlatformField
      starMapData={starMapData}
      supplierData={supplierData}
      quoteProject={quoteProject}
      viewCurrency={viewCurrency}
      mode="amount"
      showRadioGroup={showRadioGroup}
    />
  );
};

export default PlatformPriceCell;
